import React from "react";

export const IconParking = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m20.25 17.25v1.5h-1.5v-1.5m-15-6.75 1.7709-4.132c0.28828-0.67266 1.0228-1.118 1.8436-1.118h9.271c0.8208 0 1.5553 0.44531 1.8436 1.118l1.7709 4.132h-16.5zm0 0h16.5v6.75h-16.5v-6.75zm1.5 6.75v1.5h-1.5v-1.5h1.5z"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m6.75 14.25c0.41421 0 0.75-0.3358 0.75-0.75s-0.33579-0.75-0.75-0.75-0.75 0.3358-0.75 0.75 0.33579 0.75 0.75 0.75z"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m17.25 14.25c0.4142 0 0.75-0.3358 0.75-0.75s-0.3358-0.75-0.75-0.75-0.75 0.3358-0.75 0.75 0.3358 0.75 0.75 0.75z"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconParking;
